import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { Teacher } from "./Teacher";

export class Org {
  id: string;
  name: string;
  canFund: boolean;
  grades: string[] = [];
  teachers: Teacher[] = [];
  members: any[] = [];

  constructor({ id, name, grades, canFund }) {
    makeAutoObservable(this);
    this.id = id;
    this.name = name;
    this.grades = grades;
    this.canFund = canFund;
  }

  update({ grades }) {
    runInAction(() => {
      this.grades = grades;
    });
  }

  @action loadTeachers() {
    return Api.org.teachers(this.id).then((res) => {
      runInAction(() => {
        this.teachers = res.data.teachers;
      });
    });
  }

  @action loadMembers() {
    return Api.org.members(this.id).then((res) => {
      runInAction(() => {
        this.members = res.data.orgMembers;
      });
    });
  }
}
